import React, { useEffect, useState } from "react";
import MasterTable from "../common/MasterTable";
import CustomAlert from "../../helpers/CustomAlert";
import Loader from "../Loader/Loader";
import { format, isValid, parse } from "date-fns";
import { useDispatch } from "react-redux";
import HeaderWithBreadcrumb from "../common/HeaderWithBreadcrumb";
import SendToOemModal from "./SendToOemModal";
import OrderCourierFilterModal from "./OrderCourierFilterModal";

const defaultFilterData = {
  companyId: "",
  status: [],
  createdDate: "",
};

const dummyCustomerData = [
  {
    companyId: "BAG001",
    createdDate: "2025-09-20 10:30 AM",
    createdBy: "Admin",
    status: "Open",
    companyName: "5 Items",
    retailerName: "Rohit Sharma",
  },
  {
    companyId: "BAG002",
    createdDate: "2025-09-20 02:15 PM",
    createdBy: "Manager",
    status: "In Transit",
    companyName: "3 Items",
    retailerName: "Virat Kohli",
  },
  {
    companyId: "BAG003",
    createdDate: "2025-09-21 09:00 AM",
    createdBy: "System",
    status: "Accepted By Courier Hub",
    companyName: "8 Items",
    retailerName: "Hardik Pandya",
  },
  {
    companyId: "BAG004",
    createdDate: "2025-09-21 05:45 PM",
    createdBy: "Admin",
    status: "Closed",
    companyName: "2 Items",
    retailerName: "KL Rahul",
  },
  {
    companyId: "BAG005",
    createdDate: "2025-09-22 11:10 AM",
    createdBy: "Operator",
    status: "In Transit",
    companyName: "6 Items",
    retailerName: "MS Dhoni",
  },
  {
    companyId: "BAG006",
    createdDate: "2025-09-20 10:30 AM",
    createdBy: "Admin",
    status: "Open",
    companyName: "35 Items",
    retailerName: "Rohit Sharma",
  },
  {
    companyId: "BAG007",
    createdDate: "2025-09-20 02:15 PM",
    createdBy: "Manager",
    status: "In Transit",
    companyName: "13 Items",
    retailerName: "Virat Kohli",
  },
  {
    companyId: "BAG008",
    createdDate: "2025-09-21 09:00 AM",
    createdBy: "System",
    status: "Accepted By Courier Hub",
    companyName: "81 Items",
    retailerName: "Hardik Pandya",
  },
  {
    companyId: "BAG009",
    createdDate: "2025-09-21 05:45 PM",
    createdBy: "Admin",
    status: "Closed",
    companyName: "22 Items",
    retailerName: "KL Rahul",
  },
  {
    companyId: "BAG010",
    createdDate: "2025-09-22 11:10 AM",
    createdBy: "Operator",
    status: "In Transit",
    companyName: "20 Items",
    retailerName: "MS Dhoni",
  },
];

const OrderCourierHub = () => {
  const [pageSize, setPageSize] = useState(10);
  const [noData, setNoData] = useState(false);
  const [editData, setEditData] = useState({});
  const [customerData, setCustomerData] = useState(dummyCustomerData);
  const [rawMasterData, setRawMasterData] = useState([]);
  const [modalAction, setModalAction] = useState("");
  const [loading, setLoading] = useState(false);
  const [pageDetails, setPageDetails] = useState({
    pageNo: 1,
    pageSize: 10,
    totalPages: 5,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [filterData, setFilterData] = useState(defaultFilterData);
  const [columnData, setColumnData] = useState("");
  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);

  const openModalFilter = () => {
    setIsModalOpenFilter(true);
  };

  const closeModalFilter = () => {
    setIsModalOpenFilter(false);
  };

  const dispatch = useDispatch();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const modifyStructure = (response) => {
    return response?.map((user, index) => {
      let formattedCreDate = null;

      if (user?.createdDate) {
        // Match "2025-09-20 10:30 AM"
        const parsed = parse(
          user.createdDate,
          "yyyy-MM-dd hh:mm a",
          new Date()
        );
        if (isValid(parsed)) {
          formattedCreDate = parsed;
        } else {
          console.warn("Invalid createdDate:", user.createdDate);
        }
      }

      return {
        ...user,
        rawCreatedDate: user.createdDate,
        createdDate: formattedCreDate
          ? [
              format(formattedCreDate, "dd-MM-yyyy"),
              <br key={index} />,
              format(formattedCreDate, "HH:mm:ss"),
            ]
          : user.createdDate,
      };
    });
  };

  const getItemDateString = (item) => {
    const raw =
      item?.rawCreatedDate ||
      (typeof item?.createdDate === "string" ? item.createdDate : "");
    if (!raw || typeof raw !== "string") return "";

    const matchIso = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (matchIso) {
      return `${matchIso[1]}-${matchIso[2]}-${matchIso[3]}`;
    }

    const matchDmy = raw.match(/^(\d{2})-(\d{2})-(\d{4})/);
    if (matchDmy) {
      return `${matchDmy[3]}-${matchDmy[2]}-${matchDmy[1]}`;
    }

    const parsed = parse(raw, "yyyy-MM-dd hh:mm a", new Date());
    if (isValid(parsed)) {
      return format(parsed, "yyyy-MM-dd");
    }
    return "";
  };

  const applyFilters = (dataToFilter = rawMasterData, filters = filterData) => {
    let result = [...dataToFilter];

    if (filters?.companyId && filters.companyId.trim() !== "") {
      const targetBag = filters.companyId.trim().toLowerCase();
      result = result.filter(
        (item) => (item.companyId || "").trim().toLowerCase() === targetBag
      );
    }

    if (filters?.status && filters.status.length > 0) {
      const selectedStatuses = filters.status.map((s) => s.toLowerCase());
      result = result.filter((item) =>
        selectedStatuses.includes((item.status || "").trim().toLowerCase())
      );
    }

    if (filters?.createdDate && filters.createdDate.trim() !== "") {
      const selectedDate = filters.createdDate.trim();
      result = result.filter((item) => {
        const itemDate = getItemDateString(item);
        return itemDate ? itemDate === selectedDate : true;
      });
    } else {
      if (filters?.fromDate && filters.fromDate.trim() !== "") {
        const from = filters.fromDate.trim();
        result = result.filter((item) => {
          const itemDate = getItemDateString(item);
          return itemDate ? itemDate >= from : true;
        });
      }

      if (filters?.toDate && filters.toDate.trim() !== "") {
        const to = filters.toDate.trim();
        result = result.filter((item) => {
          const itemDate = getItemDateString(item);
          return itemDate ? itemDate <= to : true;
        });
      }
    }

    setCustomerData(result);
    setNoData(result.length === 0);
    setPageDetails((prev) => ({
      ...prev,
      pageNo: 1,
      totalRecords: result.length,
    }));
  };

  useEffect(() => {
    const structuredData = modifyStructure(dummyCustomerData);
    setRawMasterData(structuredData);
    applyFilters(structuredData, filterData);
  }, []);

  const customerHeader = [
    "Bag No",
    "Created Date",
    "Created By",
    "Status",
    "Items Included",
    "Start date & Time",
    "Pickup Boy",
  ];

  const customerHeaderToKeyMap = {
    "Bag No": "companyId",
    "Created Date": "createdDate",
    "Created By": "createdBy",
    Status: "status",
    "Items Included": "companyName",
    "Start date & Time": "createdDate",
    "Pickup Boy": "retailerName",
  };

  const handleCustomer = (data, actionType = "view") => {
    setModalAction(actionType);
    setColumnData(data);
    if (actionType === "send") {
      openModal();
    } else {
      let custData = customerData.find((item) => item?.id === data?.id);
      if (custData) {
        setEditData(custData);
      }
    }
  };

  const handleSuccess = () => {
    CustomAlert({
      title: "Success",
      text: "The bag has been successfully sent to the courier hub.",
      icon: "success",
      confirmButtonText: "Okay",
    });
  };

  const handleReset = () => {
    setFilterData(defaultFilterData);
    applyFilters(rawMasterData, defaultFilterData);
    setCurrentPage(1);
  };

  const totalRecord = customerData ? customerData.length : (pageDetails === null ? 0 : pageDetails.totalRecords);

  return (
    <>
      <HeaderWithBreadcrumb title="Order Courier Master" breadcrumb="Master" />
      <div>
        <div className="bg-[#FFFFFF] shadow-custom rounded-[14px] px-[10px]">
          {loading ? (
            <Loader />
          ) : (
            <>
              <MasterTable
                loading={loading}
                headers={customerHeader}
                data={customerData}
                handleAction={handleCustomer}
                filterFields={["companyId"]}
                entityType="OrderCourier"
                headerToKeyMap={customerHeaderToKeyMap}
                noData={noData}
                pageDetails={pageDetails}
                currentPage={currentPage}
                pageSize={pageSize}
                totalRecord={totalRecord}
                fetchNextData={(page, filters = filterData) =>
                  applyFilters(rawMasterData, filters)
                }
                setCurrentPage={setCurrentPage}
                setPageSize={setPageSize}
                openModalFilter={openModalFilter}
                handleReset={handleReset}
                fetchData={() => {
                  setFilterData(defaultFilterData);
                  applyFilters(rawMasterData, defaultFilterData);
                }}
                filterData={filterData}
              />
            </>
          )}
        </div>

        {isModalOpen && (
          <SendToOemModal
            show={isModalOpen}
            handleClose={() => closeModal(false)}
            callApi={() => console.log("Call API")} // Replace with actual API call function
          />
        )}

        {isModalOpenFilter && (
          <OrderCourierFilterModal
            show={isModalOpenFilter}
            handleClose={closeModalFilter}
            filterData={filterData}
            setFilterData={setFilterData}
            handleReset={handleReset}
            bagList={rawMasterData}
            applyFilters={(dummy, newFilters) =>
              applyFilters(rawMasterData, newFilters)
            }
          />
        )}
      </div>
    </>
  );
};

export default OrderCourierHub;
